import React, { useState, useEffect } from 'react';
import { showNotification } from '../../../utils/notifications';
import AddDepartment from './AddDepartment';
import gamificationService from '../../../services/gamificationService';
import userService from '../../../services/userService';
import { getAllDepartments } from '../../../services/departmentSerice';
import EditMemberModal from './EditMemberModal';
import AddMemberModal from './AddMemberModal';
import MembersTable from './MembersTable';
import AdminStatistics from './AdminStatistics';

const ProfileTeamsTab = () => {
  const [isAdmin] = useState(localStorage.getItem('userRole') === 'admin');
  const [loading, setLoading] = useState(true);

  // Members state (Populated from API)
  const [members, setMembers] = useState([]);

  // Modal states
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [showEditMemberModal, setShowEditMemberModal] = useState(false);
  const [showPointsModal, setShowPointsModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [department, setDepartments] = useState(null);
  const [DepModel, setDepModel] = useState(false);

  // Form states
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    department: '',
    jobTitle: ''
  });

  const [pointsData, setPointsData] = useState({
    memberId: null,
    points: 0,
    reason: '',
    type: 'add' // 'add' or 'remove'
  });

  // --- Fetch Data ---
  useEffect(() => {
    fetchLeaderboard();
    featchDepartments();
  }, []);

  const featchDepartments = async () => {
    try {
      const data = await getAllDepartments();
      setDepartments(data.data);
    } catch (error) {
      console.log(error);
      showNotification('could not fetch department', 'error');
    }
  }

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);
      const data = await gamificationService.getLeaderboard();

      // Map API response to Component State format
      const formattedMembers = data.map(stat => ({
        id: stat.userId,
        name: stat.userName,
        email: stat.email || 'N/A',
        department: stat.department || 'General',
        role: stat.role || 'Member',
        ecoCoins: stat.currentPoints,
        pointsEarned: stat.totalPointsEarned,
        pointsSpent: stat.totalPointsSpent || 0,
        actionsCompleted: stat.totalActions || 0,
        badges: stat.badgesCount || 0,
        level: stat.level,
        joinDate: stat.joinDate || new Date().toISOString().split('T')[0],
        status: 'active'
      }));

      setMembers(formattedMembers);
    } catch (error) {
      console.error("Error fetching leaderboard", error);
      showNotification('Erreur de chargement du classement', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveMember = (data) => {
    console.log("Updated Data:", data);
    // Call your API here: updateMember(selectedMember.id, data)...
    setShowEditMemberModal(false);
  };

  // Calculate statistics
  const activeMembers = members.filter(m => m.status === 'active');
  const totalEmployees = activeMembers.length;
  const totalActionsCompleted = activeMembers.reduce((sum, m) => sum + m.actionsCompleted, 0);
  const totalBadgesEarned = activeMembers.reduce((sum, m) => sum + m.badges, 0);
  const pendingRequests = 0; // Moved to MarketplaceTab
  const participationRate = totalEmployees > 0
    ? ((activeMembers.filter(m => m.actionsCompleted > 0).length / totalEmployees) * 100).toFixed(1)
    : '0';

  // Handlers
  const handleCreateMember = (data) => {
    // 'data' contains { name, email, department, jobTitle }
    console.log("Creating new member:", data);

    // Call your API here...
    // axios.post('/api/members', data)...

    setShowAddMemberModal(false);
  };

  const handleDeleteMember = (memberId) => {
    const member = members.find(m => m.id === memberId);
    setConfirmAction({
      type: 'delete',
      title: 'Supprimer le membre',
      message: `Êtes-vous sûr de vouloir supprimer ${member.name} ? Cette action est irréversible.`,
      onConfirm: async () => {
        try {
          await userService.deleteUser(memberId);
          showNotification(`${member.name} a été supprimé avec succès`, 'success');

          // Refresh data
          await fetchLeaderboard();

          setShowConfirmModal(false);
          setConfirmAction(null);
        } catch (error) {
          console.error('Error deleting member:', error);
          showNotification(
            error.response?.data?.message || 'Erreur lors de la suppression',
            'error'
          );
        }
      }
    });
    setShowConfirmModal(true);
  };

  const handleAttributePoints = async (e) => {
    e.preventDefault();
    const member = members.find(m => m.id === pointsData.memberId);

    if (!member) {
      showNotification('Membre introuvable', 'error');
      return;
    }

    if (!pointsData.points || !pointsData.reason.trim()) {
      showNotification('Veuillez remplir tous les champs', 'warning');
      return;
    }

    try {
      if (pointsData.type === 'add') {
        await gamificationService.awardPoints(
          pointsData.memberId,
          pointsData.points,
          pointsData.reason
        );
        showNotification(`${pointsData.points} points ajoutés à ${member.name}`, 'success');
      } else {
        await gamificationService.deductPoints(
          pointsData.memberId,
          pointsData.points,
          pointsData.reason
        );
        showNotification(`${pointsData.points} points retirés de ${member.name}`, 'success');
      }

      // Refresh leaderboard
      await fetchLeaderboard();

      // Reset form
      setShowPointsModal(false);
      setPointsData({ memberId: null, points: 0, reason: '', type: 'add' });
    } catch (error) {
      console.error('Error attributing points:', error);
      showNotification('Erreur lors de l\'attribution des points', 'error');
    }
  };
  const closeDepModel = () => {
    setDepModel(false);
  }
  const OpenDepModel = () => {
    setDepModel(true);
  }


  const openEditModal = (member) => {
    setSelectedMember(member);
    setFormData({
      name: member.name,
      email: member.email,
      department: member.department,
      jobTitle: member.jobTitle || ''
    });
    setShowEditMemberModal(true);
  };

  const openPointsModal = (member) => {
    setPointsData({ ...pointsData, memberId: member.id });
    setShowPointsModal(true);
  };

  const closeModals = () => {
    setShowAddMemberModal(false);
    setShowEditMemberModal(false);
    setShowPointsModal(false);
    setShowHistoryModal(false);
    setSelectedMember(null);
    setFormData({ name: '', email: '', department: '', jobTitle: '' });
    setPointsData({ memberId: null, points: 0, reason: '', type: 'add' });
  };

  return (
    <div className="profile-teams-tab">

      {/* ADMIN VIEW - Employee Statistics Section */}
      <AdminStatistics
        totalEmployees={totalEmployees}
        totalActionsCompleted={totalActionsCompleted}
        totalBadgesEarned={totalBadgesEarned}
        pendingRequests={pendingRequests}
        participationRate={participationRate}
      />

      {/* ADMIN SECTION - Only visible for admins */}
      {isAdmin && (
        <>
          <div className="admin-section" style={{
            background: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            padding: '25px',
            marginBottom: '30px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <h3 style={{ margin: 0, marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <i className="fas fa-user-shield"></i> Administration - Gestion des Membres
            </h3>

            {/* Members Table with Scrollbar */}
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <h4 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="fas fa-users"></i> Liste des employés
                </h4>
                <div id='actionbutton' className='flex flex-col w-[20%] h-[9em] gap-1'>
                  {/* department button */}
                  <button
                    onClick={() => OpenDepModel()}
                    style={{
                      background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))',
                      color: 'white',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '700',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                    }}
                  >
                    <i className="fas fa-user-plus"></i>
                    Ajouter un departement
                  </button>
                  {/* add member button */}
                  <button
                    onClick={() => setShowAddMemberModal(true)}
                    style={{
                      background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))',
                      color: 'white',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '700',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                    }}
                  >
                    <i className="fas fa-user-plus"></i>
                    Ajouter un membre
                  </button>
                </div>
              </div>

              <div style={{
                maxHeight: '460px',
                overflowY: 'auto',
                overflowX: 'auto',
                borderRadius: '12px',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <MembersTable
                  members={members}
                  loading={loading}
                  onOpenPoints={openPointsModal}
                  onEdit={openEditModal}
                  onDelete={handleDeleteMember}
                />
              </div>
            </div>
          </div>
        </>
      )}

      {/* MODALS */}
      {/* add department model */}
      {DepModel && (

        <AddDepartment closeModals={closeDepModel} />
      )}

      {/* Add Member Modal */}
      {showAddMemberModal && (
        <AddMemberModal
          isOpen={showAddMemberModal}
          onClose={() => setShowAddMemberModal(false)}
          onSave={handleCreateMember}
          departments={department}
        />
      )}








      {/* Edit Member Modal */}
      {showEditMemberModal && (
        <EditMemberModal
          isOpen={showEditMemberModal}
          onClose={() => setShowEditMemberModal(false)}
          onSave={handleSaveMember}
          initialData={selectedMember}
          departments={department}
        />
      )}

      {/* Points Attribution Modal */}
      {showPointsModal && (
        <div className="modal" style={{ display: 'block', background: 'rgba(0, 0, 0, 0.7)', backdropFilter: 'blur(5px)' }} onClick={closeModals}>
          <div className="modal-content" style={{
            maxWidth: '600px',
            background: 'linear-gradient(135deg, rgba(30, 39, 46, 0.98) 0%, rgba(45, 52, 54, 0.98) 100%)',
            borderRadius: '20px',
            padding: '0',
            border: '2px solid rgba(102, 126, 234, 0.3)',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)'
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{
              background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))',
              padding: '25px 30px',
              borderRadius: '18px 18px 0 0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '12px', fontSize: '20px', fontWeight: '700' }}>
                <i className="fas fa-coins"></i> Gérer les points
              </h3>
              <button onClick={closeModals} style={{
                background: 'rgba(255, 255, 255, 0.2)',
                border: 'none',
                width: '35px',
                height: '35px',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease'
              }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}>
                <i className="fas fa-times" style={{ fontSize: '18px' }}></i>
              </button>
            </div>
            <form onSubmit={handleAttributePoints} style={{ padding: '30px' }}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)' }}>
                  <i className="fas fa-exchange-alt" style={{ marginRight: '8px', color: 'var(--primary-color)' }}></i>
                  Type d'opération
                </label>
                <select
                  value={pointsData.type}
                  onChange={(e) => setPointsData({ ...pointsData, type: e.target.value })}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    background: 'rgba(255, 255, 255, 0.05)',
                    border: '2px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '10px',
                    color: 'var(--text-primary)',
                    fontSize: '14px',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                    cursor: 'pointer'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--primary-color)'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
                >
                  <option value="add" style={{ background: '#1e272e', color: '#fff' }}>➕ Ajouter des points</option>
                  <option value="remove" style={{ background: '#1e272e', color: '#fff' }}>➖ Retirer des points</option>
                </select>
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)' }}>
                  <i className="fas fa-hashtag" style={{ marginRight: '8px', color: 'var(--primary-color)' }}></i>
                  Nombre de points
                </label>
                <input
                  type="number"
                  min="1"
                  value={pointsData.points}
                  onChange={(e) => setPointsData({ ...pointsData, points: parseInt(e.target.value) })}
                  required
                  placeholder="Ex: 500"
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    background: 'rgba(255, 255, 255, 0.05)',
                    border: '2px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '10px',
                    color: 'var(--text-primary)',
                    fontSize: '14px',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--primary-color)'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)' }}>
                  <i className="fas fa-comment-dots" style={{ marginRight: '8px', color: 'var(--primary-color)' }}></i>
                  Raison
                </label>
                <textarea
                  value={pointsData.reason}
                  onChange={(e) => setPointsData({ ...pointsData, reason: e.target.value })}
                  required
                  placeholder="Ex: Action écologique complétée"
                  rows="4"
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    background: 'rgba(255, 255, 255, 0.05)',
                    border: '2px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '10px',
                    color: 'var(--text-primary)',
                    fontSize: '14px',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--primary-color)'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
                ></textarea>
              </div>
              <div style={{ display: 'flex', gap: '15px', marginTop: '30px' }}>
                <button type="button" onClick={closeModals} style={{
                  flex: 1,
                  padding: '14px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '2px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '10px',
                  color: 'var(--text-primary)',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}>
                  Annuler
                </button>
                <button type="submit" style={{
                  flex: 1,
                  padding: '14px',
                  background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))',
                  border: 'none',
                  borderRadius: '10px',
                  color: 'white',
                  fontSize: '15px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                  }}>
                  <i className="fas fa-check"></i> Confirmer
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {showConfirmModal && confirmAction && (
        <div className="modal" style={{ display: 'block', background: 'rgba(0, 0, 0, 0.7)', backdropFilter: 'blur(5px)' }} onClick={() => setShowConfirmModal(false)}>
          <div className="modal-content" style={{
            maxWidth: '450px',
            background: 'linear-gradient(135deg, rgba(30, 39, 46, 0.98) 0%, rgba(45, 52, 54, 0.98) 100%)',
            borderRadius: '20px',
            padding: '0',
            border: confirmAction.type === 'approve'
              ? '2px solid rgba(45, 149, 97, 0.4)'
              : '2px solid rgba(201, 75, 75, 0.4)',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)'
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{
              background: confirmAction.type === 'approve'
                ? 'linear-gradient(135deg, #2d9561, #28a68a)'
                : 'linear-gradient(135deg, #c94b4b, #b84855)',
              padding: '25px 30px',
              borderRadius: '18px 18px 0 0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '12px', fontSize: '18px', fontWeight: '700' }}>
                <i className={confirmAction.type === 'approve' ? 'fas fa-check-circle' : 'fas fa-times-circle'}></i>
                {confirmAction.title}
              </h3>
              <button onClick={() => setShowConfirmModal(false)} style={{
                background: 'rgba(255, 255, 255, 0.2)',
                border: 'none',
                width: '35px',
                height: '35px',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease'
              }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}>
                <i className="fas fa-times" style={{ fontSize: '16px' }}></i>
              </button>
            </div>
            <div style={{ padding: '30px', textAlign: 'center' }}>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'var(--text-primary)', marginBottom: '30px' }}>
                {confirmAction.message}
              </p>
              <div style={{ display: 'flex', gap: '15px' }}>
                <button type="button" onClick={() => setShowConfirmModal(false)} style={{
                  flex: 1,
                  padding: '14px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '2px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '10px',
                  color: 'var(--text-primary)',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}>
                  Annuler
                </button>
                <button type="button" onClick={confirmAction.onConfirm} style={{
                  flex: 1,
                  padding: '14px',
                  background: confirmAction.type === 'approve'
                    ? 'linear-gradient(135deg, #2d9561, #28a68a)'
                    : 'linear-gradient(135deg, #c94b4b, #b84855)',
                  border: 'none',
                  borderRadius: '10px',
                  color: 'white',
                  fontSize: '15px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: confirmAction.type === 'approve'
                    ? '0 4px 15px rgba(45, 149, 97, 0.4)'
                    : '0 4px 15px rgba(201, 75, 75, 0.4)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = confirmAction.type === 'approve'
                      ? '0 6px 20px rgba(45, 149, 97, 0.6)'
                      : '0 6px 20px rgba(201, 75, 75, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = confirmAction.type === 'approve'
                      ? '0 4px 15px rgba(45, 149, 97, 0.4)'
                      : '0 4px 15px rgba(201, 75, 75, 0.4)';
                  }}>
                  <i className={confirmAction.type === 'approve' ? 'fas fa-check' : (confirmAction.type === 'delete' ? 'fas fa-trash' : 'fas fa-times')}></i>
                  {confirmAction.type === 'approve' ? 'Valider' : (confirmAction.type === 'delete' ? 'Supprimer' : 'Refuser')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileTeamsTab;
